// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9588 ? "80dceb9d" : chunkId) + "." + {"97":"73d58370e6051b8e","9588":"193eb444bc9c357c"}[chunkId] + ".js";
};